import React from 'react'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { Box, ListItemIcon } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import SettingsIcon from '@mui/icons-material/Settings'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove'
import { useStyles } from './style'

const options = [
  { label: 'Edit', action: 'rename', icon: <EditIcon /> },
  { label: 'Manage', action: 'manage', icon: <SettingsIcon /> },
  { label: 'Order item up', action: 'orderUp', icon: <ArrowUpwardIcon /> },
  { label: 'Order item down', action: 'orderDown', icon: <ArrowDownwardIcon /> },
  { label: 'Move to', action: 'move', icon: <DriveFileMoveIcon data-testid='DriveFileMoveIcon' /> }
]

export function CategoryItemMenu ({ actions }) {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const handleClick = (event) => setAnchorEl(event.currentTarget)
  const handleClose = action => {
    actions[action]()
    setAnchorEl(null)
  }

  return (
    <>
      <Button aria-controls='category-item-menu' aria-haspopup='true' onClick={handleClick}>
        <MoreVertIcon />
      </Button>
      <Menu
        id='category-item-menu'
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        keepMounted
        open={Boolean(anchorEl)}
        classes={{ paper: classes.root, list: classes.list }}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {options.filter(o => !!actions[o.action]).map(({ label, action, icon }, idx) =>
          <MenuItem onClick={() => handleClose(action)} key={idx}>
            <Box display='flex' flex={1}>
              <Box flex={1}>{label}</Box>
              <ListItemIcon className={classes.listItemIcon}>
                {icon}
              </ListItemIcon>
            </Box>
          </MenuItem>
        )}
      </Menu>
    </>
  )
}
